<template>
	<app-table
		icon-excel
		name="tools-list"
		title="Lista de Herramientas"
		:clean-search="cleanSearch"
		:filter-columns="false"
		:rows="rows"
		:columns="columns"
		:main-list="false"
		class="is-not-selectable no-main-list"
		@on-search-event="onSearch"
	>
		<template slot="excel">
			<app-button class="new-tool" icon="add" @click="goTo('new-tool')"/>
		</template>
		<template slot="rows" slot-scope="{ row }">
			<td v-show="showRow(columns, 1)" class="is-not-selectable border-top">{{ row.name }}</td>
			<td v-show="showRow(columns, 2)" class="border-top">{{ row.description }}</td>
			<td v-show="showRow(columns, 3)" class="border-top">{{ row.type }}</td>
			<td v-show="showRow(columns, 4)" class="border-top">
				<v-layout wrap align-center justify-start>
					<app-tooltip-button
						color="primary"
						text="Configurar"
						icon="settings"
						@click-icon="settingTool(row)"
					/>
					<app-tooltip-button
						text="Editar"
						img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/new-file-1-(4).svg"
						@click-icon="editTool(row)"
					/>
					<app-tooltip-button
						v-if="row.flagDelete"
						img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/delete-button-(1).svg"
						text="Eliminar"
						color="info"
						@click-icon="deleteTool(row)"
					/>
				</v-layout>
			</td>
		</template>
	</app-table>
</template>
<script>
import appButton from '@/components/shared/app-button';

function onSearch() {}

function editTool({ code }) {
	this.goTo('edit-tool', { params: { code } });
}

async function deleteTool(row) {
	await this.$store.dispatch('tool/delete', row.id);
	this.showNotification(
		`La herramienta: "${row.name}", fue eliminada.`,
		'success',
	);
}

function settingTool(tool) {
	const { code, id } = tool;
	this.goTo('levels-tool', { params: { toolCode: code, toolId: id } });
}

function data() {
	return {
		cleanSearch: false,
	};
}

export default {
	name: 'tools-list',
	components: {
		appButton,
	},
	data,
	methods: {
		deleteTool,
		editTool,
		onSearch,
		settingTool,
	},
	props: {
		columns: {
			required: true,
			type: Array,
		},
		rows: {
			required: true,
			type: Array,
		},
	},
};
</script>
<style lang="scss" scoped>
.new-tool {

}
</style>


// WEBPACK FOOTER //
// src/components/configuration/tools/tools-list.vue